import { isNewUser, UserInfo } from '~domains/auth';

export const getAnalyticsUserRole = (data: UserInfo) => {
  return isNewUser(data) ? 'NEW_PARTNER' : data.employeeRole;
};
